import axios from "axios";
import {
  installTelemetryInterceptors,
  startTelemetry,
} from "./diagnostics/telemetry";

const instance = axios.create({
  validateStatus: (status) => status < 500,
});

// SHER-320 — kick off the periodic / lifecycle telemetry flush once, lazily
// at module load. No-op if already started or in a non-browser env.
try { startTelemetry(); } catch (_) { /* never break requests */ }

// Install the shared traceability + telemetry interceptors. `withBreadcrumbs`
// also emits api breadcrumbs and fires the notable-event flushes (5xx /
// network-error). The single per-request x-correlation-id uuid feeds both the
// telemetry event and the breadcrumb so they can be joined.
installTelemetryInterceptors(instance, { withBreadcrumbs: true });

export default instance;
